import React from 'react';

import HeaderContainer from 'containers/header';
import FooterContainer from 'containers/footer';
import ConfirmationContainer from 'containers/shopping-cart/confirmation-container';

const ShoppingCartConfirmation = () => {
  return (
    <div>
      <HeaderContainer />
      <ConfirmationContainer />
      <FooterContainer />
    </div>
  );
};

export default ShoppingCartConfirmation;
